import { render } from "./Modal2.vue?vue&type=template&id=102791d0&scoped=true"
const script = {}

import "./Modal2.vue?vue&type=style&index=0&id=102791d0&scoped=true&lang=css"

import exportComponent from "E:\\Vue_Project\\JamoatFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-102791d0"]])

export default __exports__